const pre = 'project-';

export default [{
  path: '/project/proList',
  name: `${pre}proList`,
  meta: {
    title: '我的项目'
  },
  component: () =>
    import ('@/views/project/proList')
},
  {
    path: '/project/companyList',
    name: `${pre}companyList`,
    meta: {
      title: '我的企业'
    },
    component: () =>
      import ('@/views/project/companyList')
  },
  {
    path: '/project/companyOperation',
    name: `${pre}companyOperation`,
    meta: {
      title: '企业操作'
    },
    component: () =>
      import ('@/views/project/companyOperation')
  },
  {
    path: '/project/companyInfo',
    name: `${pre}companyInfo`,
    meta: {
      title: '企业基本信息'
    },
    component: () =>
      import ('@/views/project/companyInfo')
  },
  {
    path: '/project/companyVerification',
    name: `${pre}companyVerification`,
    meta: {
      title: '企业核查'
    },
    component: () =>
      import ('@/views/project/companyVerification')
  },
  {
    path: '/project/workRecords',
    name: `${pre}workRecords`,
    meta: {
      title: '核查记录'
    },
    component: () =>
      import ('@/views/project/workRecords')
  },
  {
    path: '/project/problemCheckTaskIndex',
    name: `${pre}problemCheckTaskIndex`,
    meta: {
      title: '现场问题'
    },
    component: () =>
      import ('@/views/project/problemCheckTaskIndex')
  },
  {
    path: '/project/problemDetail',
    name: `${pre}problemDetail`,
    meta: {
      title: '问题详情'
    },
    component: () =>
      import ('@/views/project/problemDetail')
  },
  {
    path: '/project/problem',
    name: `${pre}problem`,
    meta: {
      title: '现场问题上传'
    },
    component: () =>
      import ('@/views/project/problem')
  },
  {
    path: '/project/problemCache',
    name: `${pre}problemCache`,
    meta: {
      title: '暂存问题'
    },
    component: () =>
      import ('@/views/project/problemCache')
  },
  {
    path: '/project/problemCheckTask',
    name: `${pre}problemCheckTask`,
    meta: {
      title: '问题检查记录'
    },
    component: () =>
      import ('@/views/project/problemCheckTask')
  },
  {
    path: '/project/problemFollow',
    name: `${pre}problemFollow`,
    meta: {
      title: '问题跟踪'
    },
    component: () =>
      import ('@/views/project/problemFollow')
  },
  {
    path: '/project/problemFollowCheckTask',
    name: `${pre}problemFollowCheckTask`,
    meta: {
      title: '问题跟踪'
    },
    component: () =>
      import ('@/views/project/problemFollowCheckTask')
  },
  {
    path: '/project/problemFollowRecords',
    name: `${pre}problemFollowRecords`,
    meta: {
      title: '问题跟进记录'
    },
    component: () =>
      import ('@/views/project/problemFollowRecords')
  },
  {
    path: '/project/addProblemFollowRecord',
    name: `${pre}addProblemFollowRecord`,
    meta: {
      title: '添加问题跟进记录'
    },
    component: () =>
      import ('@/views/project/addProblemFollowRecord')
  },
  {
    path: '/project/completeProblem',
    name: `${pre}completeProblem`,
    meta: {
      title: '完成整改'
    },
    component: () =>
      import ('@/views/project/completeProblem')
  },
  {
    path: '/project/completeProblemInfo',
    name: `${pre}completeProblemInfo`,
    meta: {
      title: '完成整改'
    },
    component: () =>
      import ('@/views/project/completeProblemInfo')
  },
  {
    path: '/project/addCompany',
    name: `${pre}addCompany`,
    meta: {
      title: '新建企业'
    },
    component: () =>
      import ('@/views/project/addCompany')
  },
  {
    path: '/project/allCompanyList',
    name: `${pre}allCompanyList`,
    meta: {
      title: '企业信息'
    },
    component: () =>
      import ('@/views/project/allCompanyList')
  },
  {
    path: '/project/modifyCompanyInfo',
    name: `${pre}modifyCompanyInfo`,
    meta: {
      title: '修改企业信息'
    },
    component: () =>
      import ('@/views/project/modifyCompanyInfo')
  },
  {
    path: '/project/allWorkRecords',
    name: `${pre}allWorkRecords`,
    meta: {
      title: '核查记录'
    },
    component: () =>
      import ('@/views/project/allWorkRecords')
  },
  {
    path: '/project/thirdPartyCompany',
    name: `${pre}thirdPartyCompany`,
    meta: {
      title: '添加企业'
    },
    component: () =>
      import ('@/views/project/thirdPartyCompany')
  },
  {
    path: '/project/companyArchives',
    name: `${pre}companyArchives`,
    meta: {
      title: '一企一档'
    },
    component: () =>
      import  ('@/views/project/companyArchives')
  },
]
